<div class="modal-header">
    <h4 class="modal-title">Your session will expire in {{remainingTime}} minutes.</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">Please save your work and log in again.</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="login()">LOGIN</button>
  </div>
